export function trackCta(name, destination = "") {
  if (typeof window === "undefined" || !name) return;

  const detail = {
    name,
    destination,
    path: window.location.pathname,
  };

  window.dispatchEvent(new CustomEvent("uun:cta", { detail }));

  if (typeof window.gtag === "function") {
    window.gtag("event", "select_content", {
      content_type: "cta",
      item_id: name,
      link_url: destination,
    });
  }
}
